import React from 'react'

export default function BankInnerPageEligibility1({data}) {
  console.log("data",data)
  return (
    <section className="feature-jobs bg_white pt-50 pb-140">
    <div className="container">
      <div className="row justify-content-between align-items-center">
        <div className="col-md-6">
          <div className="section-title text-start">
            <h3
              className="mb-0 wow fadeInRight"
              style={{ visibility: "visible", animationName: "fadeInRight" }}
            >
             Eligibility Criteria
            </h3>
          </div>
        </div>

      </div>
      <div className="row pt-60" >
      
          <div className="feature-job-tab">
            <ul className="feature-job-list" style={{
        display:"flex",justifyContent:"center",flexDirection:"row",flexWrap:"wrap",alignItems:"center",gap:"20px"
      }}>
     <li className="mt-0" id='textWid'>
            <a >
              <div
                className="single-feature-job wow fadeInUp"
                data-wow-delay="0.1s"
                style={{
                  visibility: "visible",
                  animationDelay: "0.1s",
                  animationName: "fadeInUp"
                }}
              >
                <p className="job-title1"  style={{fontSize:"19px"}} >
           Minimum Salary -  {data.minimumSalary}
                </p>
                <div className="d-flex flex-wrap">
                  <div className="job-location me-3" style={{
                    alignItems:"center",
                    display:"flex",
                    justifyContent:"center"
                  }}>
                    {" "}
                   <img src={data.bankImage} alt={data.bankName} style={{width:"15px",height:"15px"}} /> &nbsp;
                    {data.bankName}
                  </div>
                  
                </div>
              </div>
            </a>
          </li>


          <li className="mt-0" id='textWid'>
            <a >
              <div
                className="single-feature-job wow fadeInUp"
                data-wow-delay="0.1s"
                style={{
                  visibility: "visible",
                  animationDelay: "0.1s",
                  animationName: "fadeInUp"
                }}
              >
                <p className="job-title1"  style={{fontSize:"19px"}} >
            Interest Rate -  {data.interestRate}
                </p>
                <div className="d-flex flex-wrap">
                  <div className="job-location me-3" style={{
                    alignItems:"center",
                    display:"flex",
                    justifyContent:"center"
                  }}>
                    {" "}
                   <img src={data.bankImage} alt={data.bankName} style={{width:"15px",height:"15px"}} /> &nbsp;
                    {data.bankName}
                  </div>
                  
                </div>
              </div>
            </a>
          </li>
            


         

          <li className="mt-0" id='textWid'>
            <a >
              <div
                className="single-feature-job wow fadeInUp"
                data-wow-delay="0.1s"
                style={{
                  visibility: "visible",
                  animationDelay: "0.1s",
                  animationName: "fadeInUp"
                }}
              >
                <p className="job-title1"  style={{fontSize:"19px"}} >
           EMI Due Date -  {data.emiDueDate}
                </p>
                <div className="d-flex flex-wrap">
                  <div className="job-location me-3" style={{
                    alignItems:"center",
                    display:"flex",
                    justifyContent:"center"
                  }}>
                    {" "}
                   <img src={data.bankImage} alt={data.bankName} style={{width:"15px",height:"15px"}} /> &nbsp;
                    {data.bankName}
                  </div>
                  
                </div>
              </div>
            </a>
          </li>

      

     
          <li className="mt-0" id='textWid'>
            <a >
              <div
                className="single-feature-job wow fadeInUp"
                data-wow-delay="0.1s"
                style={{
                  visibility: "visible",
                  animationDelay: "0.1s",
                  animationName: "fadeInUp"
                }}
              >
                <p className="job-title1"  style={{fontSize:"19px"}} >
          Age -  {data.age}
                </p>
                <div className="d-flex flex-wrap">
                  <div className="job-location me-3" style={{
                    alignItems:"center",
                    display:"flex",
                    justifyContent:"center"
                  }}>
                    {" "}
                   <img src={data.bankImage} alt={data.bankName} style={{width:"15px",height:"15px"}} /> &nbsp;
                    {data.bankName}
                  </div>
                  
                </div>
              </div>
            </a>
          </li>
          <li className="mt-0" id='textWid'>
            <a >
              <div
                className="single-feature-job wow fadeInUp"
                data-wow-delay="0.1s"
                style={{
                  visibility: "visible",
                  animationDelay: "0.1s",
                  animationName: "fadeInUp"
                }}
              >
                <p className="job-title1"  style={{fontSize:"19px"}} >
            CIBIL Score -  {data.cibilScore}
                </p>
                <div className="d-flex flex-wrap">
                  <div className="job-location me-3" style={{
                    alignItems:"center",
                    display:"flex",
                    justifyContent:"center"
                  }}>
                    {" "}
                   <img src={data.bankImage} alt={data.bankName} style={{width:"15px",height:"15px"}} /> &nbsp;
                    {data.bankName}
                  </div>
                  
                </div>
              </div>
            </a>
          </li>
          <li className="mt-0" id='textWid'>
            <a >
              <div
                className="single-feature-job wow fadeInUp"
                data-wow-delay="0.1s"
                style={{
                  visibility: "visible",
                  animationDelay: "0.1s",
                  animationName: "fadeInUp"
                }}
              >
                <p className="job-title1"  style={{fontSize:"19px"}} >
            Ducuments Required -  {data.documents}
                </p>
                <div className="d-flex flex-wrap">
                  <div className="job-location me-3" style={{
                    alignItems:"center",
                    display:"flex",
                    justifyContent:"center"
                  }}>
                    {" "}
                   <img src={data.bankImage} alt={data.bankName} style={{width:"15px",height:"15px"}} /> &nbsp;
                    {data.bankName}
                  </div>
                  
                </div>
              </div>
            </a>
          </li>

       

   





            </ul>
          </div>
   
      
      </div>
    </div>
  </section>
  
  )
}
